import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { UserListComponent } from './user-list/user-list.component';


const routes: Routes = [
    {
        path: 'users',
        component : UserListComponent
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations : [],
})
export class UserRoutingModule {

}


// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/users/user.routing.ts